import React, {Component} from 'react'
import { connect } from 'react-redux'

// import styles
import './index.scss'

// import components
import Modal from '../../components/Modal'

// Actions
import { getUserPunchStats } from '../../../actions/punchclock'

// Utils
import { translation } from '../../../utils/helpers'

// Elements
import Divider from '../../elements/divider'
import Inline from '../../elements/inline'
import LabelWrapper from '../../elements/labelWrapper'

class PunchStatsModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false,
      stats: []
    }
    this.renderStats = this.renderStats.bind(this)
  }

  componentDidMount () {
    this.getStats(this.props)
  }

  getStats (props) {
    this.setState({
      stats: []
    })
    let data = {
      UserId: props.id
    }
    this.props.getUserPunchStats(data).then((res) => {
      this.setState({
        stats: res.data
      })
    }, () => {
      window.toastr.error(translation('Could not get user punch stats'), translation('216'))
      this.props.onClose()
    })
  }

  renderStats (stats, key) {
    const renderStat = (item, k) => {
      if (item.PunchIn === '' && item.PunchOut === '') return null
      return (
        <div key={k}>
          <span>{item.PunchIn}</span>-<span>{item.PunchOut}</span>
        </div>
      )
    }
    let overAllText = ''
    if (stats.OverallHours !== '') {
      overAllText = '(' + stats.OverallHours + ')'
    }
    return (
      <LabelWrapper key={key} labelText={(<Inline>{translation(stats.DateDictionaryKey)} <span>{stats.Date} {overAllText}</span></Inline>)}>
        {stats.PunchStats.map(renderStat)}
        {stats.DateDictionaryKey === 169 && <Divider />}
      </LabelWrapper>
    )
  }

  render () {
    let title = translation('Punch stats') + ': ' + this.props.name
    return (
      <div className='punchstats__modal'>
        <Modal {...this.props} header={title} overflowHidden={this.state.overflowHidden}>
          {this.state.stats.map(this.renderStats)}
        </Modal>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getUserPunchStats
})(PunchStatsModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/PunchStatsModal/index.js